import { render, staticRenderFns } from "./recependHis.vue?vue&type=template&id=655e5430&scoped=true"
import script from "./recependHis.vue?vue&type=script&lang=js"
export * from "./recependHis.vue?vue&type=script&lang=js"
import style0 from "./recependHis.vue?vue&type=style&index=0&id=655e5430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655e5430",
  null
  
)

export default component.exports